<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item class="personal">
                    <el-page-header @back="goBack" title="邀约数据"
                                    :content="userName+'丨个人数据：（电话总数：'+phoneCount+'丨微信总数：'+wechatCount+'丨见面总数：'+meetCount+'）'">
                    </el-page-header>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="日期">
                    <el-date-picker
                            v-model="dataForm.dateTemp"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" v-if="isAuth('invite-list-add')"
                               @click="addOrUpdateHandle()">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('invite-list-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                    <el-button type="primary" @click="exportData()">导出数据
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="phoneCount"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="电话数">
                </el-table-column>
                <el-table-column
                        prop="wechatCount"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="微信数">
                </el-table-column>
                <el-table-column
                        prop="meetCount"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="见面数">
                </el-table-column>
                <el-table-column
                        prop="inviteDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="creationDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                                   v-if="isAuth('invite-list-edit')"
                                   @click="addOrUpdateHandle(scope.row.id)">编辑
                        </el-button>
                        <el-button type="danger" size="mini"
                                   v-if="isAuth('invite-list-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <iv-user-add-or-update v-if="addOrUpdateVisible" ref="ivUser"
                               @getDataList="getDataList()"></iv-user-add-or-update>
    </div>
</template>

<script>
    import {IvUser} from "../../api/inviteUser";
    import {DateFormat} from "../../utils/dateformat";
    import IvUserAddOrUpdate from './invite-user-add-or-update';

    export default {
        name: "invite-user-list",
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                phoneCount: '',
                wechatCount: '',
                meetCount: '',
                dataForm: {
                    dateTemp: ''
                },
                userId: '0',
                userName: '',
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            IvUserAddOrUpdate
        },
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        methods: {
            //数据导出
            exportData() {
                let sheet = this.userName + '丨个人数据';
                let columns = [
                    {key: 'id', title: '编号'},
                    {key: 'phoneCount', title: '电话数'},
                    {key: 'wechatCount', title: '微信数'},
                    {key: 'meetCount', title: '见面数'},
                    {key: 'inviteDate', title: '日期'},
                    {key: 'creationDate', title: '创建时间'}
                ];
                IvUser.getIvUsers(this.userId).then(res => {
                    if (res.code === 0) {
                        let exportList = res.invites;
                        this.Excel.exportExcel(columns, exportList, sheet);
                    } else {
                        this.$message.info('数据太多无法导出，请联系管理员！')
                    }
                })
            },
            // 返回
            goBack() {
                this.$router.push({path: '/invite-user'})
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             * @param type
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                this.userId = this.$route.query.userId ? this.$route.query.userId : localStorage.getItem('userId');
                this.userName = this.$route.query.userName ? this.$route.query.userName : localStorage.getItem('userName');
                let dateList = this.dataForm.dateTemp ? this.dataForm.dateTemp : [];
                let dateStart = dateList.length === 2 ? DateFormat.dateFormat(dateList[0]) : '';
                let dateEnd = dateList.length === 2 ? DateFormat.dateFormat(dateList[1]) : '';
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'userId': this.userId,
                    'dateStart': dateStart,
                    'dateEnd': dateEnd
                };
                IvUser.getIvPersonal(params).then(res => {
                    if (res.code === 0) {
                        this.phoneCount = res.personal.phoneCount;
                        this.wechatCount = res.personal.wechatCount;
                        this.meetCount = res.personal.meetCount;
                        this.dataList = res.personal.page.list;
                        this.totalPage = res.personal.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                let userId = Number(this.userId);
                this.$nextTick(() => {
                    this.$refs.ivUser.init(id, userId)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将删除个人邀约数据哦, 确定吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    IvUser.deleteIvUser(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>
    .personal {
        padding-left: 10px;
        font-weight: bolder;
        letter-spacing: 1px;
    }
</style>
